import ExploitationApi from '@/api/exploitation';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('exploitation');
builder.addStatePart('batiments', null, numTiers => ExploitationApi.getBatiments(numTiers));
builder.addStatePart('lots', null, numTiers => ExploitationApi.getLots(numTiers));
builder.addStatePart('exploitations', null, numTiers => ExploitationApi.getExploitations(numTiers), 'NONE', 60);

export default builder.build();
